<div *ngIf='orders'>
  <div class='form-container' *ngIf='(orders && orders.length === 0) || orders.length > 0' id='top'>
    <!-- HEADER -->
    <div class='col-12 row heading'>
      <div class='results-heading-title'>
        <div class='subtitle'>{{ 'STOCK_COUNT.CREATE_RESULTS_ORDERS.TITLE' | translate }}</div>
      </div>
    </div>
    <!-- PLACEHOLDER UITLEG -->
    <div class='row heading explain'>
      <div class='col-4'>
        <span>{{ 'STOCK_COUNT.LABELS.EXPLAINED' | translate }}</span>
      </div>
      <div class='col-8'></div>
    </div>
    <!-- COLUMNS -->
    <div class='col-12 row bottom-line bold show-from-sm sorters' *ngIf='orders.length > 0'>
      <span class='sorter col-md col-container'>
        {{ 'STOCK_COUNT.LABELS.COUNTED_INCLUDED' | translate }}
      </span>
      <span class='sorter col-md col-container' *ngFor='let col of columns'>{{ col.colName }}</span>
    </div>

    <!-- ROWS -->
    <div *ngFor='let order of orders' class='striped-col'>
      <div class='col-md-12 order_line'>
        <div class='content'>
          <div class='row order_data'>
            <div class='order_data-data'>
              <!-- COMPONENT -->
              <app-stock-count-order
                class='col-md col-12 row cell-row cell soft-line'
                [columns]='columns'
                [order]='order'
                [shipTos]='shipTos'
                [definitions]='definitions'
                [selectedOrders]='selectedOrders'
                (checkboxChanged)='checkboxChanged($event)'
              ></app-stock-count-order>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BUTTONS -->
    <div class='form-container'>
      <div class='hr'></div>
      <div class='buttons save-button'>
        <div class='hr-thick'></div>
        <eps-button
          type="link"
          (buttonClick)="cancelClicked()"
          label="SHARED.BUTTONS.CANCEL"
          ></eps-button>
        <eps-button
          type="primary"
          (buttonClick)="countBtnClicked()"
          buttonIcon="check"
          label="STOCK_COUNT.BUTTONS.COUNT_RESULTS"
          ></eps-button>
      </div>
    </div>
  </div>
</div>
